const HEIGHTS = [14, 26, 34, 22, 30, 18, 28];

export const Equalizer = ({ playing = true, color = "#FFB703", className = "" }) => (
  <div data-testid="equalizer" className={`flex items-end gap-1 h-9 ${className}`} aria-hidden>
    {HEIGHTS.map((h, i) => (
      <span
        key={i}
        className={`w-1.5 rounded-full ${playing ? "eq-bar" : "eq-idle"}`}
        style={{
          height: `${h}px`,
          background: color,
          animationDelay: `${i * 0.13}s`,
          animationDuration: `${0.7 + (i % 3) * 0.18}s`,
        }}
      />
    ))}
  </div>
);
